const SheriffLLogo = ({
    width = 40,
    height = 54,
    backgroundColor = "#000000",
    letterColor = "#FFFFFF",
    className = "",
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 47 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            {/* Rounded square background */}
            <rect
                x="0"
                y="0"
                width="47"
                height="58"
                rx="6"
                fill={backgroundColor}
            />

            {/* Custom typographical L */}
            <path
                d="M20.0035 46.152V12.168L18.0195 12.04C17.8488 12.04 17.6782 12.04 17.5075 12.04C15.4595 12.04 13.7102 12.5307 12.2595 13.512C10.8088 14.4933 10.0835 15.9867 10.0835 17.992C10.0835 18.8027 10.2115 19.5067 10.4675 20.104L9.9555 20.488C9.48617 19.976 9.2515 19.1013 9.2515 17.864C9.2515 16.584 9.6995 15.368 10.5955 14.216C11.4915 13.064 12.6435 12.296 14.0515 11.912C14.0942 11.912 14.5848 11.848 15.5235 11.72V11.592L14.0515 11.656C9.9555 11.144 6.6275 9.992 4.0675 8.2C1.5075 6.36533 0.2275 3.74133 0.2275 0.327999L0.9955 0.263996C0.9955 2.22666 1.48617 3.93333 2.4675 5.384C3.44883 6.792 4.79283 7.90133 6.4995 8.712C9.65683 10.1627 13.4968 11.016 18.0195 11.272L20.8995 11.464V46.152C20.8995 48.712 20.4302 50.632 19.4915 51.912C18.5528 53.1493 16.9528 53.768 14.6915 53.768C13.5395 53.768 12.5795 53.64 11.8115 53.384L11.9395 52.744C12.8782 52.9573 13.7315 53.064 14.4995 53.064C16.6328 53.064 18.0835 52.5093 18.8515 51.4C19.6195 50.2907 20.0035 48.5413 20.0035 46.152ZM23.4595 14.28V50.312C27.0435 52.1467 30.3075 53.064 33.2515 53.064C36.2382 53.064 38.3075 52.5947 39.4595 51.656C40.6542 50.7173 41.2515 49.0533 41.2515 46.664C41.2515 45.896 41.1448 45.192 40.9315 44.552L41.6355 44.232C41.9342 44.9573 42.0835 45.768 42.0835 46.664C42.0835 49.224 41.4222 51.0587 40.0995 52.168C38.7768 53.2773 36.7502 53.832 34.0195 53.832C30.0515 53.832 26.2328 52.8293 22.5635 50.824V14.28C22.5635 11.72 23.0328 9.82133 23.9715 8.584C24.9102 7.304 26.5102 6.664 28.7715 6.664C29.9235 6.664 30.8835 6.792 31.6515 7.048L31.5235 7.688C30.5848 7.47466 29.7315 7.368 28.9635 7.368C26.8302 7.368 25.3795 7.92266 24.6115 9.032C23.8435 10.1413 23.4595 11.8907 23.4595 14.28Z"
                fill={letterColor}
            />
        </svg>
    );
};

export default SheriffLLogo;
